<script setup lang="ts">
import { AuctionStatus } from "fungi-types";
import { useI18n } from "vue-i18n";
import { Lock } from "lucide-vue-next";
import { computed } from "vue";

const { t } = useI18n();

const props = withDefaults(
  defineProps<{
    loading?: boolean;
    auctionStatus?: AuctionStatus;
    saleLocked?: string | null;
  }>(),
  {
    loading: true,
    isInteractive: true,
  }
);

const saleIsLocked = computed(() => {
  if (props.saleLocked) {
    const now = new Date();
    const unlockDate = new Date(props.saleLocked);
    return now < unlockDate;
  }
  return false;
});

const emits = defineEmits(["list", "unlist"]);
</script>

<template>
  <ButtonPrimary class="w-full" v-if="auctionStatus === AuctionStatus.ENDED" disabled>
    <span> {{ t("pages.marketplace.trade.sold") }} </span>
  </ButtonPrimary>
  <ButtonPrimary
    class="w-full"
    v-else-if="
      auctionStatus &&
      [AuctionStatus.IN_PROGRESS, AuctionStatus.PENDING_TO_BE_EXECUTED].includes(auctionStatus)
    "
    @click="emits('unlist')"
  >
    <span v-if="loading || auctionStatus === AuctionStatus.PENDING_TO_BE_EXECUTED" class="py-[2px]">
      <icon-fgc-loading />
    </span>
    <span v-else> {{ t("pages.myDeck.unlist") }} </span>
  </ButtonPrimary>

  <ButtonPrimary v-else class="w-full justify-between group" @click="emits('list')">
    <span v-if="loading" class="py-[2px]">
      <icon-fgc-loading />
    </span>
    <div class="flex justify-center items-center gap-1 text-base h-full" v-else>
      <div class="flex-grow text-center">
        {{ t("pages.myDeck.list") }}
      </div>
      <div
        v-if="saleIsLocked"
        class="flex items-center justify-center px-1.5 py-[6px] bg-white/20 h-full rounded-full mr-2 group-hover:bg-black"
      >
        <Lock class="h-3 w-3 p-0 group-hover:text-white" stroke-width="2" />
      </div>
    </div>
  </ButtonPrimary>
</template>

<style scoped lang="scss"></style>
